import { useMemo } from 'react';
import { IProductFilter } from '../../constants/product/productFilter.constant';
import { useAppSelector } from '../store/useStore';

interface useGetFilterHasSelectedOptionProps {
  filter: 'all' | IProductFilter;
}

export const useGetFilterHasSelectedOption = (props: useGetFilterHasSelectedOptionProps) => {
  const productFilterStates = useAppSelector((state) => state.productFilter);

  const isFilterHasSelectedOption = useMemo<boolean>(() => {
    let isFilterHasSelectedOption = false;

    productFilterStates.globalProductFilters.forEach((filter) => {
      // 전체 필터에 대해 활성화된 옵션이 있는지 검색
      if (props.filter === 'all') {
        filter.options.forEach((option) => {
          if (option.isSelected && !option.isDefault) {
            isFilterHasSelectedOption = true;
          }
        });
      }

      // 파라미터로 받은 필터에 대해 활성화된 옵션이 있는지 검색
      else if (props.filter?.key === filter.key) {
        filter.options.forEach((option) => {
          if (option.isSelected && !option.isDefault) {
            isFilterHasSelectedOption = true;
          }
        });
      }
    });

    return isFilterHasSelectedOption;
  }, [productFilterStates]);

  return { isFilterHasSelectedOption };
};
